"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _grid = _interopRequireDefault(require("../../styles/grid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledDiv = _styledComponents["default"].div.withConfig({
  displayName: "Grid__StyledDiv",
  componentId: "sc-1o91qoi-0"
})(["", ""], _grid["default"]);

var Grid = function Grid(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledDiv, props, children);
};

Grid.propTypes = {
  /**
   * The content to be displayed in the grid
   */
  children: _propTypes["default"].node
};
var _default = Grid;
exports["default"] = _default;